module.exports = __webpack_public_path__ + "static/media/smeNormal.25ff2afd.svg";